import { ErrorHandler, Injectable, Injector } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    constructor(private injector: Injector) { }

    handleError(error: any): void {
        const chunkFailedMessage = /Loading chunk [\d]+ failed/;
        const dynamicImportMessage = /Failed to fetch dynamically imported module/;

        if (chunkFailedMessage.test(error.message) || dynamicImportMessage.test(error.message)) {
            console.error('Chunk load error detected:', error);
            // Check if we've already reloaded to avoid infinite loops
            const lastReload = sessionStorage.getItem('last_chunk_reload');
            const now = Date.now();

            if (!lastReload || now - parseInt(lastReload) > 10000) {
                sessionStorage.setItem('last_chunk_reload', now.toString());
                window.location.reload();
            }
        } else {
            console.error(error);
        }
    }
}
